import { SelectOptionHide } from '@App/stores/search/models/select-option-hide'
import { SearchCriterion } from '@App/stores/search/models/search-criterion'

/**
 * Helper method to generate a SearchCriterion from a SelectOptionHide.
 * @param option - The SelectOptionHide object.
 * @param isFixed - Whether the criterion is fixed (default: false).
 * @param isDisabled
 * @param searchTerm
 * @returns A SearchCriterion object.
 */
export const generateSearchCriterionFromOption = <T extends Record<never, never>>(
    option: SelectOptionHide<T>,
    isFixed = false,
    isDisabled = false,
    searchTerm?: string
): SearchCriterion<T> => ({
    id: option.id,
    selectedOption: option,
    searchTerm: searchTerm ?? '',
    isFixed: isFixed,
    isDisabled: isDisabled,
})
